<template>
  <div>
    <kbArticle />
  </div>
</template>

<script>
import kbArticle from "../components/knowledge-base/kb-article.vue";

export default {
  name: "KnowledgeBaseArticlePage",
  components: {
    kbArticle,
  },
};
</script>
